export default __webpack_public_path__ + "static/media/Montserrat-Medium.fd53b73a.woff";